import { configCatFeatureFlagProvider } from './configcat-feature-flag-provider';
import { createFeatureFlagStore } from './feature-flag-store';

export const featureFlags = createFeatureFlagStore(configCatFeatureFlagProvider);
